import React, { useEffect, useState } from "react";
import Input from "../../../../components/FormElement/Search";
import TextArea from "../../../../components/FormElement/TextArea";
import ImageUpload from "../../../../components/FormElement/ImageUpload";
import { useFormik } from "formik";
import { FormWrapper } from "../style";
import * as Yup from "yup";
import Button from "../../../../components/FormElement/Button";
import { useHideModal } from "../../../../hooks";
import { useShowAlert } from "../../../../hooks/useAlerts";
import LangTab from "../../../../components/FormElement/LangTab";
import service from "../../../../services/services";
import Spinner from "../../../../components/Spinner/FullScreen";

function Form({ edit, refreshData }) {
  const [loading, setLoading] = useState(false);
  const { hideModal } = useHideModal();
  const { error } = useShowAlert();
  const [fileList, setFileList] = useState([]);
  const [logoList, setLogoList] = useState([]);
  const [language, setLanguage] = useState("UZL");

  const validationSchema = Yup.object({
    title: Yup.object().shape({
      UZL: Yup.string().required("Kiritish shart!"),
      UZK: Yup.string().required("Kiritish shart!"),
      RUS: Yup.string().required("Kiritish shart!"),
      ENG: Yup.string().required("Kiritish shart!"),
    }),
    desc: Yup.object().shape({
      UZL: Yup.string().required("Kiritish shart!"),
      UZK: Yup.string().required("Kiritish shart!"),
      RUS: Yup.string().required("Kiritish shart!"),
      ENG: Yup.string().required("Kiritish shart!"),
    }),
    fileList: Yup.array().min(1).required("Kiritish shart!"),
    logoList: Yup.array().min(1).required("Kiritish shart!"),
  });

  const formik = useFormik({
    initialValues: {
      title: {
        UZL: "",
        UZK: "",
        RUS: "",
        ENG: "",
      },
      desc: {
        UZL: "",
        UZK: "",
        RUS: "",
        ENG: "",
      },

      fileList: [],
      logoList: [],
    },
    validationSchema,
    onSubmit: (values) => {
      const formData = new FormData();
      formData.append("title[UZL]", values.title.UZL);
      formData.append("title[RUS]", values.title.RUS);
      formData.append("title[UZK]", values.title.UZK);
      formData.append("title[ENG]", values.title.ENG);
      formData.append("desc[UZL]", values.desc.UZL);
      formData.append("desc[RUS]", values.desc.RUS);
      formData.append("desc[UZK]", values.desc.UZK);
      formData.append("desc[ENG]", values.desc.ENG);
      logoList?.forEach((el) => {
        if (el.originFileObj) {
          formData.append(`file`, el.originFileObj);
        }
      });
      fileList?.forEach((el) => {
        if (el.originFileObj) {
          formData.append(`image`, el.originFileObj);
        }
      });
      setLoading(true);
      if (edit) {
        service
          .update(edit, formData)
          .then(() => {
            hideModal();
            refreshData();
          })
          .catch((err) => {
            console.log(err);
            error(
              "Server bilan bog'lanishda xatolik yuzaga keldi. Iltimos qaytadan urinib ko'ring"
            );
          })
          .finally(() => {
            setLoading(false);
          });
      } else {
        service
          .create(formData)
          .then(() => {
            hideModal();
            refreshData();
          })
          .catch((err) => {
            console.log(err);
            error(
              "Server bilan bog'lanishda xatolik yuzaga keldi. Iltimos qaytadan urinib ko'ring"
            );
          })
          .finally(() => {
            setLoading(false);
          });
      }
    },
  });

  useEffect(() => {
    if (edit) {
      setLoading(true);
      service
        .getOne(edit)
        .then((resp) => {
          formik.setValues({
            title: {
              UZL: resp.title?.UZL,
              UZK: resp.title?.UZK,
              RUS: resp.title?.RUS,
              ENG: resp.title?.ENG,
            },
            desc: {
              UZL: resp.desc?.UZL,
              UZK: resp.desc?.UZK,
              RUS: resp.desc?.RUS,
              ENG: resp.desc?.ENG,
            },
          });
          resp?.logo && setLogoList([resp?.logo]);
          resp?.photo && setFileList([resp?.photo]);
        })
        .catch((err) => {
          console.log(err);
          error(
            "Server bilan bog'lanishda xatolik yuzaga keldi. Iltimos qaytadan urinib ko'ring"
          );
        })
        .finally(() => {
          setLoading(false);
        });
    }
  }, [edit]);

  const onLangChange = (key) => {
    setLanguage(key);
  };

  useEffect(() => {
    formik.setFieldValue("fileList", fileList);
    formik.setFieldValue("logoList", logoList);
  }, [fileList, logoList]);

  if (loading) return <Spinner />;
  return (
    <FormWrapper>
      <form onSubmit={formik.handleSubmit}>
        <LangTab defaultActiveKey="1" onChange={onLangChange} />
        <Input
          id="title"
          name="title"
          width={100}
          label={"Xizmat turi"}
          placeholder="Xizmat turi"
          onChange={(e) => {
            formik.setFieldValue(`title.${language}`, e.target.value);
          }}
          value={formik.values?.title[language]}
          status={formik?.errors?.title && formik.touched.title ? "error" : ""}
        />
        <TextArea
          id="desc"
          label={"Izoh"}
          name="desc"
          onChange={(e) => {
            formik.setFieldValue(`desc.${language}`, e.target.value);
          }}
          value={formik.values?.desc[language]}
          status={formik?.errors?.desc && formik.touched.desc ? "error" : ""}
          height={formik.values.desc.length <= 100 ? "80px" : "120px"}
        />
        <div className="img">
          <ImageUpload
            maxCount={1}
            multiple={true}
            fileList={fileList}
            setFileList={setFileList}
            status={
              formik?.errors?.fileList && formik.touched.fileList ? true : false
            }
          />
        </div>
        <div className="img">
          <ImageUpload
            label="Logo"
            maxCount={1}
            multiple={true}
            fileList={logoList}
            setFileList={setLogoList}
            status={
              formik?.errors?.logoList && formik.touched.logoList ? true : false
            }
          />
        </div>
        <Button
          htmlType="submit"
          text={edit ? "Tahrirlash" : "Saqlash"}
          width="100%"
        />
      </form>
    </FormWrapper>
  );
}

export default Form;
